import { TextField, Button, FormControl, FormLabel, Switch, FormControlLabel, MenuItem } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useState } from "react";

const TextToNeo4jForm = () => {
  const [textToNeo4jFormData, setTextToNeo4jFormData] = useState({
    neo4j_uri: "",
    neo4j_user: "",
    neo4j_password: "",
    json_path: "",
    is_append_mode: false,
    with_embeddings: false,
    embedding_model_name: "",
  });

  const embeddingModelOptions = ["Model A", "Model B", "Model C"];

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setTextToNeo4jFormData({
      ...textToNeo4jFormData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(textToNeo4jFormData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={3}>
        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Neo4j URI</FormLabel>
            <TextField name="neo4j_uri" value={textToNeo4jFormData.neo4j_uri} onChange={handleChange} />
          </FormControl>
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Neo4j User</FormLabel>
            <TextField name="neo4j_user" value={textToNeo4jFormData.neo4j_user} onChange={handleChange} />
          </FormControl>
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Neo4j Password</FormLabel>
            <TextField type="password" name="neo4j_password" value={textToNeo4jFormData.neo4j_password} onChange={handleChange} />
          </FormControl>
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>JSON Path</FormLabel>
            <TextField name="json_path" value={textToNeo4jFormData.json_path} onChange={handleChange} />
          </FormControl>
        </Grid>

       

        <Grid size={6}>
          <FormControlLabel
            control={<Switch name="is_append_mode" checked={textToNeo4jFormData.is_append_mode} onChange={handleChange} />}
            label="Append Mode"
          />
        </Grid>

        <Grid size={6}>
          <FormControlLabel
            control={<Switch name="with_embeddings" checked={textToNeo4jFormData.with_embeddings} onChange={handleChange} />}
            label="With Embeddings"
          />
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <FormLabel>Embedding Model Name</FormLabel>
            <TextField select name="embedding_model_name" value={textToNeo4jFormData.embedding_model_name} onChange={handleChange}>
              {embeddingModelOptions.map((model) => (
                <MenuItem key={model} value={model}>
                  {model}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
        </Grid>

        <Grid size={12} textAlign="center">
          <Button variant="contained" color="primary" type="submit">
            Submit
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default TextToNeo4jForm;
